/**
 * Videresending som tar med søkestrengen og #-ankeret (#153).
 *
 * `<Navigate to="/x" />` mister `?…`; en gammel push-lenke som en gang får
 * parametere skal lande med dem.
 */
import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router';

export function RedirectKeepingSearch({ to }: { to: string }): ReactNode {
  const { search, hash } = useLocation();
  return <Navigate to={{ pathname: to, search, hash }} replace />;
}
